/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-10 11:16:05
 * @LastEditors: steFan
 * @LastEditTime: 2020-03-24 17:43:54
 */
let str = localStorage.getItem('dowUrl');
try {
    str = str ? JSON.parse(str) : '';  
} catch {
    str = '';
}

let jackpotUrl = localStorage.getItem('jackpotUrl');
try {
    jackpotUrl = jackpotUrl ? JSON.parse(jackpotUrl) : ''; 
} catch {
    jackpotUrl = '';
}


let customerServiceUrl = localStorage.getItem('customerServiceUrl') || "";
export default {
    'host': 'http://159.138.131.189', //新测试环境
    'loginVersion': 'v1.0.0',
    'baseUrl': '',
    'dowUrl': str || 'https://appdownload.011312.com/',
    'jackpotUrl': jackpotUrl,
    'customerServiceUrl': customerServiceUrl,
    'ws': 500,
    'hs': 500,
    'scales': 0.8,
    // 页面服务器
    'codeUrl': '',
    // 图片服务器
    'imgHost': '',
    'appVer': '1.0.0',
    'protocolVer': '1.0',
    'reqId': 0,
    'numVer': 'v2.0.1',
    // themeIndex: sessionStorage.getItem("theme") || 1,
    'themeIndex': 1,
    'clientIp': '101.231.217.194',
    'iosDownloadUrl': '',
    'androidDownloadUrl': '',
    'pcDownloadUrl': '',
    'pcMainUrl': '',
    'pcDomainImgUrl':'',
    'phoneModel': '', //手机型号
    'fingerprint': '123', //设备唯一标识
    'themeImgUrl': function(f, fileType) {
        let M = fileType ? fileType : 'png';
        // let q = sessionStorage.getItem("theme")
        let q = 1;
        if (q * 1 === 17) {
            q = 16;
        }
        if (q) {
            return require('@/assets/image/theme/theme' + q + '/' + f + '.' + M);
        }
    }

};